<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="detailLoader || !details"></loading>

	<table class="table">
		<thead>
			<tr>
				<th>{{ 'adminstat.billing.domain_billing.domainZone' | translate }}</th>
				<th>{{ 'adminstat.common.Money' | translate }}</th>
				<th>{{ 'adminstat.common.paidCount' | translate }}</th>
				<th>{{ 'adminstat.billing.domain_billing.totalDomainCount' | translate }}</th>
				<th>{{ 'adminstat.billing.domain_billing.list' | translate }}</th>
			</tr>
		</thead>
		
		<tbody>
			<tr *ngFor="let detail of details">
				<td>
					{{ detail.domainZone }}
				</td>
				
				<td>
					{{ detail.moneyCount / 100 }}$
				</td>
				
				<td>
					{{ detail.paidCount }}
				</td>
				
				<td>
					{{ detail.domainCount }}
				</td>
				
				<td>
					<table class="table">
						<thead>
							<tr>
								<th>{{ 'adminstat.billing.domain_billing.tariff' | translate }}</th>
								<th>{{ 'adminstat.common.Status' | translate }}</th>
								<th>{{ 'adminstat.common.Site' | translate }}</th>
							</tr>
						</thead>
						
						<tbody>
							<tr *ngFor="let domainInfo of detail.domainList">
								<td>
									{{ domainInfo.period }}
								</td>
								
								<td>
									<span [class]="domainInfo.status == 'registered' ? 'badge badge-success' : 'badge badge-danger'">{{ domainInfo.status }}</span>
								</td>
								
								<td>
									<a target="_blank" rel="noreferrer" [href]="'http://' + domainInfo.name">{{ domainInfo.name }}</a>
								</td>
							</tr>
						</tbody>
					</table>	
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
